"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreButton = exports.ItemTextPosition = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@headlessui/react");
const Text_1 = require("../Text");
const Icon_1 = require("../Icon");
const Button_1 = require("../Button");
const clsx_1 = __importDefault(require("clsx"));
var ItemTextPosition;
(function (ItemTextPosition) {
    ItemTextPosition["LEFT"] = "left";
    ItemTextPosition["RIGHT"] = "right";
})(ItemTextPosition = exports.ItemTextPosition || (exports.ItemTextPosition = {}));
function MoreButton({ items, disabled, }) {
    return (react_1.default.createElement(react_2.Menu, { as: "div", className: "relative inline-block text-left" },
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_2.Menu.Button, { "data-testid": "morebutton", className: "bg-transparent inline-flex w-full justify-center px-4 py-2 text-sm font-medium text-gray-700", disabled: disabled },
                react_1.default.createElement(Icon_1.Icon.TripleDot, { className: "text-icon-subdued -rotate-90" }))),
        react_1.default.createElement(react_2.Transition, { as: react_1.Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" },
            react_1.default.createElement(react_2.Menu.Items, { className: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-surface-default shadow-default" }, items.map((item) => (react_1.default.createElement(react_2.Menu.Item, { key: item.label },
                react_1.default.createElement(Button_1.Button, { onClick: () => {
                        item.onClick();
                    }, type: item.type ? item.type : Button_1.ButtonType.QUIET, size: Button_1.ButtonSize.MD, fullWidth: true, left: item.position === 'left', right: item.position === 'right', className: (0, clsx_1.default)('my-1', item.className), loading: item.loading },
                    react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, className: "cursor-pointer text-left" }, item.label)))))))));
}
exports.MoreButton = MoreButton;
//# sourceMappingURL=MoreButton.js.map